import ScrapingStatusBadge from './ScrapingStatusBadge';

export default ScrapingStatusBadge;
